// src/Components/WhatsAppButton.tsx
import React from "react";
import { FaWhatsapp } from "react-icons/fa";

interface WhatsAppButtonProps {
  phoneNumber?: string;
}

const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({
  phoneNumber = "6281513951020", // ✅ nomor management Kalia Siska
}) => {
  // TEMPLATE PESAN BARU (ENDORSE / BOOKING)
  const message = `Halo Admin Kalia Siska 👋

Saya tertarik untuk bekerja sama / booking performance.

Berikut detail saya:

👤 *Nama:*  
🏢 *Perusahaan / Brand:*  
📍 *Lokasi Event:*  
📅 *Tanggal Event:*  
🎤 *Jenis Kerja Sama:* (Endorse / Event / Kolaborasi)  
✍️ *Detail Tambahan:*  

Mohon informasi lebih lanjut ya 🙏`;

  const encodedMessage = encodeURIComponent(message);

  return (
    <a
      href={`https://wa.me/${phoneNumber}?text=${encodedMessage}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-3 rounded-full shadow-lg z-50 transition transform hover:scale-110">
      <div className="relative">
        {/* 🔴 Notifikasi */}
        <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full animate-ping"></span>
        <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full"></span>

        <FaWhatsapp className="w-10 h-10" />
      </div>
    </a>
  );
};

export default WhatsAppButton;
